// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@rpsc/Overrides/Widgets/Basic/LinkList";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { color, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.titleWrapper = {
    css: css`
        margin-bottom: 8px;
    `,
};
linkListStyles.linkListWrapper = {
    css: css`
        text-transform: none;
    `,
};
linkListStyles.title = {
    variant: "h6",
    forwardAs: "p",
    css: css`
        margin: 0;
    `,
};

linkListStyles.linkWrapper = {
    css: css`
        display: flex;
        gap: 14px;
        flex-wrap: wrap;
        & .list-link {
            & ${TypographyStyle} {
                font-size: 12px;
                font-weight: ${fontConfig.weight.regular};
                letter-spacing: 0;
                line-height: 17px;
            }
        }
        &.horizontal {
            align-items: center;
            & .list-link {
                gap: 13px;
                &:not(:last-child) {
                    &::after {
                        content: "";
                        border-right: 1px solid ${color("primary")};
                        height: 13px;
                        display: inline-block;
                    }
                }
            }
        }
        &.vertical {
            flex-direction: column;
        }
    `,
};

linkListStyles.titleLink = {
    typographyProps: {
        color: "text",
        weight: fontConfig.weight.bold,
        size: 14,
    },
};
